import { DateTimeFormatter, Duration, Instant, LocalDate, TemporalAccessor } from "@js-joda/core";
import { Locale } from "@js-joda/locale_en-us";

export const DISTANT_PAST = Instant.parse("0000-01-01T00:00:00Z");
export const DISTANT_FUTURE = Instant.parse("9999-12-31T23:59:59Z");
const MILLIS_PER_DAY = 24 * 60 * 60 * 1000;

export const localDateRange = ({
  startInclusive,
  endExclusive,
}: {
  startInclusive: LocalDate;
  endExclusive: LocalDate;
}): LocalDate[] => {
  const dates = [];
  for (
    let current = startInclusive;
    current.isBefore(endExclusive);
    current = current.plusDays(1)
  ) {
    dates.push(current);
  }
  return dates;
};

export const formatDate = (pattern: string, temporal: TemporalAccessor) =>
  DateTimeFormatter.ofPattern(pattern).withLocale(Locale.US).format(temporal);

export const daysBetween = (a: Instant, b: Instant) =>
  Duration.between(a, b).toMillis() / MILLIS_PER_DAY;
